exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ri-header[data-v-c0c0dc54] { overflow: hidden; margin-bottom: 12px;\n}\n.ri-title[data-v-c0c0dc54] { font-size: 16px; font-weight: 600; line-height: 32px;\n}\n.float-right[data-v-c0c0dc54] { float: right;\n}\n", ""]);

// exports
